// Menuapiservice.js
import axios from "axios";
const BASE_URL =
    process.env.REACT_APP_API_URL;


// ✅ Get vendorId and authToken once from localStorage
const vendorId = localStorage.getItem("vendorId");
const authToken = localStorage.getItem("authToken");

// ✅ Debug logs for missing values
// if (!vendorId) console.warn("⚠️ vendorId is missing in localStorage");
if (!authToken) console.warn("⚠️ authToken is missing in localStorage");

// ✅ Common headers for both GET and POST
const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${authToken}`,
};

/**
 * GET menu by vendor
 * Fetch all dishes for the vendor
 */
export const getMenuByVendor = async () => {
    const vendorId = localStorage.getItem("vendorId");
    const authToken = localStorage.getItem("authToken");
    // console.log("vendorId:", vendorId, "authToken:", authToken);

    if (!authToken) throw new Error("authToken is missing");

    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
    };

    // Append vendorId if it exists  https://backend.maamaas.com/catering/api/dishes/getAll
    const url = vendorId
        ? `${BASE_URL}/api/admin/dishes/getAll?vendorId=${vendorId}`
        : `${BASE_URL}/api/user/dishes/getAll`;

    const response = await fetch(url, { headers });
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    const data = await response.json();
    // console.log("🔹 GET Menu Data from API:", data);
    return data;
};


export const getMenu = async () => {
    const vendorId = localStorage.getItem("vendorId");
    const authToken = localStorage.getItem("authToken");
    // console.log("vendorId:", vendorId, "authToken:", authToken);

    if (!authToken) throw new Error("authToken is missing");

    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
    };

    // Append vendorId if it exists  https://backend.maamaas.com/catering/api/dishes/getAll
    const url = vendorId
        ? `${BASE_URL}/catering/api/user/dishes/getAll`
        : `${BASE_URL}/catering/api/user/dishes/getAll`;

    const response = await fetch(url, { headers });
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    const data = await response.json();
    // console.log("🔹 GET Menu Data from API:", data);
    return data;
};
/**
 * POST a new dish
 * Add a new dish for the vendor
 * @param {Object} dishData - The body for the API
 * {
 *   "dishId": 0,
 *   "dishName": "string",
 *   "dishDescription": "string",
 *   "dishPrice": 0,
 *   "parentId": 0,
 *   "dishImage": "string",
 *   "discountPercentage": 0,
 *   "effectivePrice": 0,
 *   "available": true
 * }
 */
/**
 * POST a new dish using FormData (image as file)
 * @param {FormData} formData - FormData containing "image" file and "data" JSON string
 */
export const addNewDish = async (formData) => {
    const authToken = localStorage.getItem("authToken");
    if (!authToken) throw new Error("authToken is missing");

    try {
        // console.log("Adding new dish via FormData:", formData);

        const response = await fetch(`${BASE_URL}/api/admin/dishes`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${authToken}`, // don't set Content-Type
            },
            body: formData, // send FormData
        });

        // console.log("Fetch called for POST new dish, Response status:", response.status);

        if (!response.ok) {
            const text = await response.text();
            console.error("POST API HTTP Error Text:", text);
            throw new Error(`POST error! Status: ${response.status}`);
        }

        const data = await response.json();
        // console.log("✅ New Dish Added:", data);
        return data;
    } catch (error) {
        console.error("Add Dish API Error:", error);
        throw error;
    }
};

export const uploadDish = async (
    formData,
    token
) => {
    try {

        const response = await axios.post(
            `${BASE_URL}/food/api/admin/dish/upload`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return response.data;

    } catch (error) {

        console.error(
            "UPLOAD Dish Error:",
            error
        );

        throw error;
    }
};

// ==============================
// GET DISH BY ID
// ==============================

export const getDishById = async (
    dishId,
    token
) => {
    try {

        const response = await axios.get(
            `${BASE_URL}/food/api/dish/${dishId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return response.data;

    } catch (error) {

        console.error(
            "GET Dish Error:",
            error
        );

        throw error;
    }
};

export const updateDish = async (
    dishId,
    formData,
    token
) => {
    try {

        const response = await axios.put(
            `${BASE_URL}/food/api/edit/dish/${dishId}`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }
        );

        return response.data;

    } catch (error) {

        console.error(
            "UPDATE Dish Error:",
            error
        );

        throw error;
    }
};

export const updateCategory = async (
    categoryId,
    formData,
    token
) => {
    try {

        const response = await axios.put(
            `${BASE_URL}/food/api/admin/category/${categoryId}`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return response.data;

    } catch (error) {

        console.error(
            "UPDATE Category Error:",
            error
        );

        throw error;
    }
};

export const deleteDish = async (
    dishId,
    token
) => {
    try {

        const response = await axios.delete(
            `${BASE_URL}/food/api/delete/dish/${dishId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return response.data;

    } catch (error) {

        console.error(
            "DELETE Dish Error:",
            error
        );

        throw error;
    }
};

export const deleteCategory = async (
    categoryId,
    token
) => {
    try {

        const response = await axios.delete(
            `${BASE_URL}/food/api/admin/category/${categoryId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return response.data;

    } catch (error) {

        console.error(
            "DELETE Category Error:",
            error
        );

        throw error;
    }
};


// ================= GET VALID IMAGE URL =================
export const getValidImageUrl =
    (url) => {

        if (
            !url ||
            typeof url !==
            "string" ||
            url.trim() ===
            "" ||
            url === "null" ||
            url ===
            "undefined" ||
            url === "string"
        ) {

            return null;
        }

        if (
            url.startsWith(
                "data:image/"
            )
        ) {

            return url;
        }

        if (
            url.startsWith(
                "http://"
            ) ||
            url.startsWith(
                "https://"
            )
        ) {

            return url;
        }

        if (
            url.includes(
                "amazonaws.com"
            ) ||
            url.includes(
                "X-Amz-"
            )
        ) {

            return url;
        }

        const imageExtensions =
            [
                ".jpg",
                ".jpeg",
                ".png",
                ".gif",
                ".webp",
                ".svg",
                ".avif",
                ".jfif",
            ];

        const hasImageExtension =
            imageExtensions.some(
                (ext) =>
                    url
                        .toLowerCase()
                        .endsWith(
                            ext
                        )
            );

        if (
            hasImageExtension
        ) {

            if (
                url.includes(
                    "dishes_images/"
                )
            ) {

                return `http://img.maamaas.com:8080/foodandbevarages/${url}`;

            } else if (
                url.includes(
                    "category_images/"
                )
            ) {

                return `http://img.maamaas.com:8080/foodandbevarages/${url}`;
            }

            return `https://backend.maamaas.com${url.startsWith("/")
                ? url
                : "/uploads/" +
                url
                }`;
        }

        return null;
    };

// ================= FETCH FOOD MENU DATA =================
export const fetchFoodMenuDataAPI =
    async () => {

        try {

            const authToken =
                localStorage.getItem(
                    "authToken"
                );

            const headers =
                authToken
                    ? {
                        Authorization:
                            `Bearer ${authToken}`,
                    }
                    : {};

            // Categories cou
            const categoriesResponse =
                await fetch(
                    `${BASE_URL}/food/api/getall/catageory-dish`,
                    {
                        headers,
                    }
                );

            let categoriesData =
                [];

            if (
                categoriesResponse.ok
            ) {

                const data =
                    await categoriesResponse.json();

                if (
                    Array.isArray(
                        data
                    )
                ) {

                    categoriesData =
                        data;

                } else if (
                    data.data &&
                    Array.isArray(
                        data.data
                    )
                ) {

                    categoriesData =
                        data.data;

                } else if (
                    data.categories &&
                    Array.isArray(
                        data.categories
                    )
                ) {

                    categoriesData =
                        data.categories;

                } else if (
                    data.result &&
                    Array.isArray(
                        data.result
                    )
                ) {

                    categoriesData =
                        data.result;
                }
            }

            // Dishes API
            const dishesResponse =
                await fetch(
                    `${BASE_URL}/food/api/getall/dish`,
                    {
                        headers,
                    }
                );

            let transformedDishes =
                [];

            if (
                dishesResponse.ok
            ) {

                const data =
                    await dishesResponse.json();

                let dishesData =
                    [];

                if (
                    Array.isArray(
                        data
                    )
                ) {

                    dishesData =
                        data;

                } else if (
                    data.data &&
                    Array.isArray(
                        data.data
                    )
                ) {

                    dishesData =
                        data.data;

                } else if (
                    data.dishes &&
                    Array.isArray(
                        data.dishes
                    )
                ) {

                    dishesData =
                        data.dishes;

                } else if (
                    data.result &&
                    Array.isArray(
                        data.result
                    )
                ) {

                    dishesData =
                        data.result;
                }

                transformedDishes =
                    dishesData
                        .map(
                            (dish) => {

                                const dishId =
                                    dish.id ||
                                    dish.dishId ||
                                    dish.dishID ||
                                    "";

                                const dishName =
                                    dish.name ||
                                    dish.dishName ||
                                    dish.dish ||
                                    "";

                                const dishImage =
                                    dish.image ||
                                    dish.imageUrl ||
                                    dish.img ||
                                    "";

                                const category =
                                    dish.category ||
                                    dish.catageory ||
                                    dish.cat ||
                                    {};

                                const categoryId =
                                    category?.catageoryId ||
                                    category?.categoryId ||
                                    category?.id ||
                                    dish.catageoryId ||
                                    dish.categoryId ||
                                    null;

                                const categoryName =
                                    category?.catageoryName ||
                                    category?.categoryName ||
                                    category?.name ||
                                    "";

                                return {
                                    id:
                                        dishId,

                                    name:
                                        dishName,

                                    image:
                                        dishImage,

                                    catageoryId:
                                        categoryId,

                                    categoryName:
                                        categoryName,

                                    categoryImage:
                                        category?.image ||
                                        "",
                                };
                            }
                        )
                        .filter(
                            (dish) =>
                                dish.id
                        );
            }

            return {
                categories:
                    categoriesData,

                dishes:
                    transformedDishes,
            };

        } catch (error) {

            console.error(
                "❌ Error fetching food menu:",
                error
            );

            throw error;
        }
    };

// ================= ADD FOOD CATEGORY =================
// export const addFoodCategoryAPI =
//     async (
//         quickForm
//     ) => {

//         try {

//             const authToken =
//                 localStorage.getItem(
//                     "authToken"
//                 );

//             if (!authToken) {
//                 throw new Error(
//                     "Please login again"
//                 );
//             }

//             const categoryObj = {
//                 catageoryId:
//                     0,

//                 catageoryName:
//                     quickForm.catageory.trim(),

//                 image: "",
//             };

//             const formData =
//                 new FormData();

//             formData.append(
//                 "category",

//                 new Blob(
//                     [
//                         JSON.stringify(
//                             categoryObj
//                         ),
//                     ],
//                     {
//                         type:
//                             "application/json",
//                     }
//                 )
//             );

//             if (
//                 quickForm.image
//             ) {

//                 formData.append(
//                     "categoryImg",
//                     quickForm.image
//                 );
//             }

//             const response =
//                 await fetch(
//                     `${BASE_URL}/food/api/admin/catageory-dish`,
//                     {
//                         method: "POST",

//                         headers: {
//                             Authorization:
//                                 `Bearer ${authToken}`,
//                         },

//                         body:
//                             formData,
//                     }
//                 );

//             const text =
//                 await response.text();

//             if (!response.ok) {
//                 throw new Error(
//                     text
//                 );
//             }

//             return text;

//         } catch (error) {

//             console.error(
//                 "❌ Category add error:",
//                 error
//             );

//             throw error;
//         }
//     };
export const addFoodCategoryAPI = async (quickForm) => {
    try {
        const authToken = localStorage.getItem("authToken");
        if (!authToken) throw new Error("Please login again");

        const categoryObj = {
            catageoryId: 0,
            catageoryName: quickForm.catageory.trim(),
            image: null,
        };

        const formData = new FormData();
        formData.append("category", new Blob([JSON.stringify(categoryObj)], { type: "application/json" }));

        if (quickForm.image) {
            formData.append("categoryImg", quickForm.image);
        }

        const response = await fetch(
            `${BASE_URL}/food/api/admin/catageory-dish`,
            {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
                body: formData,
            }
        );

        const text = await response.text();
        if (!response.ok) throw new Error(text);
        return text;
    } catch (error) {
        console.error("❌ Category add error:", error);
        throw error;
    }
};
// ================= UPDATE CATERING DISH =================
export const updateCateringDishAPI =
    async (editForm) => {

        try {

            const authToken =
                localStorage.getItem(
                    "authToken"
                );

            if (!authToken) {
                throw new Error(
                    "No auth token found. Please login."
                );
            }

            const dishPayload = {
                dishId:
                    editForm.id,

                dishName:
                    editForm.name,

                dishDescription:
                    editForm.description ||
                    editForm.category ||
                    "",

                dishPrice:
                    Number(
                        editForm.price
                    ),

                parentId:
                    editForm.parentId ||
                    0,

                discountPercentage:
                    Number(
                        editForm.discount ||
                        0
                    ),

                effectivePrice:
                    Number(
                        editForm.effectivePrice ||
                        0
                    ),

                dishType:
                    editForm.type ===
                        "veg"
                        ? "Veg"
                        : editForm.type ===
                            "nonveg"
                            ? "Non_veg"
                            : "Drinks",

                available:
                    editForm.available ??
                    true,
            };

            const formData =
                new FormData();

            formData.append(
                "dishData",

                new Blob(
                    [
                        JSON.stringify(
                            dishPayload
                        ),
                    ],
                    {
                        type:
                            "application/json",
                    }
                )
            );

            if (
                editForm.image instanceof
                File
            ) {

                formData.append(
                    "image",
                    editForm.image
                );
            }

            const response =
                await fetch(
                    `${BASE_URL}/catering/api/admin/${editForm.id}`,
                    {
                        method: "PUT",

                        headers: {
                            Authorization:
                                `Bearer ${authToken}`,
                        },

                        body:
                            formData,
                    }
                );

            const text =
                await response.text();

            if (!response.ok) {

                throw new Error(
                    `PUT error! Status: ${response.status} | ${text}`
                );
            }

            return JSON.parse(
                text
            );

        } catch (error) {

            console.error(
                "❌ Failed to update item:",
                error
            );

            throw error;
        }
    };

// ================= IMPORT CATERING MENU =================
export const importCateringMenuAPI =
    async (file) => {

        try {

            const authToken =
                localStorage.getItem(
                    "authToken"
                );

            if (!authToken) {
                throw new Error(
                    "No auth token found. Please login again."
                );
            }

            const formData =
                new FormData();

            formData.append(
                "file",
                file
            );

            const response =
                await fetch(
                    `${BASE_URL}/catering/api/admin/import`,
                    {
                        method: "POST",

                        headers: {
                            Authorization:
                                `Bearer ${authToken}`,

                            Accept:
                                "*/*",
                        },

                        body:
                            formData,
                    }
                );

            const text =
                await response.text();

            if (!response.ok) {

                throw new Error(
                    `HTTP ${response.status} - ${text}`
                );
            }

            return JSON.parse(
                text
            );

        } catch (error) {

            console.error(
                "🚨 Import failed:",
                error
            );

            throw error;
        }
    };

// ================= ADD CATERING SUBCATEGORY =================
export const addCateringSubcategoryAPI =
    async (
        detailForm,
        editRowId
    ) => {

        try {

            const authToken =
                localStorage.getItem(
                    "authToken"
                );

            if (!authToken) {
                throw new Error(
                    "No auth token found. Please login."
                );
            }

            const dishData = {
                dishId: 0,

                dishName:
                    detailForm.name ||
                    "",

                dishDescription:
                    detailForm.description ||
                    detailForm.category ||
                    "",

                dishPrice:
                    Number(
                        detailForm.price ||
                        0
                    ),

                parentId:
                    editRowId,

                discountPercentage:
                    Number(
                        detailForm.discount ||
                        0
                    ),

                effectivePrice:
                    Number(
                        detailForm.price ||
                        0
                    ) -
                    (
                        Number(
                            detailForm.price ||
                            0
                        ) *
                        Number(
                            detailForm.discount ||
                            0
                        )
                    ) /
                    100,

                available:
                    true,

                dishType:
                    detailForm.type ===
                        "veg"
                        ? "Veg"
                        : detailForm.type ===
                            "nonveg"
                            ? "Non_veg"
                            : "Drinks",
            };

            const formData =
                new FormData();

            formData.append(
                "dishData",

                new Blob(
                    [
                        JSON.stringify(
                            dishData
                        ),
                    ],
                    {
                        type:
                            "application/json",
                    }
                )
            );

            if (
                detailForm.image instanceof
                File
            ) {

                formData.append(
                    "image",
                    detailForm.image
                );
            }

            const response =
                await fetch(
                    `${BASE_URL}/catering/api/admin/dishes`,
                    {
                        method: "POST",

                        headers: {
                            Authorization:
                                `Bearer ${authToken}`,
                        },

                        body:
                            formData,
                    }
                );

            const text =
                await response.text();

            if (!response.ok) {

                throw new Error(
                    text
                );
            }

            return JSON.parse(
                text
            );

        } catch (error) {

            console.error(
                "❌ Failed to save subcategory:",
                error
            );

            throw error;
        }
    };

// ================= ADD CATERING DISH =================
export const addCateringDishAPI =
    async (quickForm) => {

        try {

            const token =
                localStorage.getItem(
                    "authToken"
                );

            const dishData = {
                dishName:
                    quickForm.name,

                dishPrice:
                    Number(
                        quickForm.price ||
                        0
                    ),

                available:
                    true,

                dishDescription:
                    quickForm.description ||
                    "",
            };

            const formData =
                new FormData();

            formData.append(
                "dishData",

                new Blob(
                    [
                        JSON.stringify(
                            dishData
                        ),
                    ],
                    {
                        type:
                            "application/json",
                    }
                )
            );

            if (
                quickForm.image instanceof
                File
            ) {

                formData.append(
                    "image",
                    quickForm.image
                );
            }

            const response =
                await fetch(
                    `${BASE_URL}/catering/api/admin/dishes`,
                    {
                        method: "POST",

                        headers: {
                            Authorization:
                                `Bearer ${token}`,
                        },

                        body:
                            formData,
                    }
                );

            const text =
                await response.text();

            if (!response.ok) {

                throw new Error(
                    text
                );
            }

            return JSON.parse(
                text
            );

        } catch (error) {

            console.error(
                "❌ Error adding dish:",
                error
            );

            throw error;
        }
    };

// ================= DELETE CATERING DISH =================
export const deleteCateringDishAPI =
    async (id) => {

        try {

            const authToken =
                localStorage.getItem(
                    "authToken"
                );

            if (!authToken) {
                throw new Error(
                    "No auth token found. Please login."
                );
            }

            const response =
                await fetch(
                    `${BASE_URL}/catering/api/admin/delete/${id}`,
                    {
                        method: "DELETE",

                        headers: {
                            Accept:
                                "*/*",

                            Authorization:
                                `Bearer ${authToken}`,
                        },
                    }
                );

            if (!response.ok) {

                const text =
                    await response.text();

                throw new Error(
                    `DELETE error! Status: ${response.status} | ${text}`
                );
            }

            return true;

        } catch (error) {

            console.error(
                "❌ Failed to delete item:",
                error
            );

            throw error;
        }
    };

export const addDish = async (
    formData,
    token
) => {
    const response = await axios.post(
        `${BASE_URL}/dishes`,
        formData,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

    return response.data;
};

// ======================
// UPDATE DISH
// ======================
export const updateDishs = async (
    dishId,
    formData,
    token
) => {
    const response = await axios.put(
        `${BASE_URL}/catering/api/admin/${dishId}`,
        formData,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

    return response.data;
};

// ======================
// DELETE DISH
// ======================
export const deleteDishs = async (
    dishId,
    token
) => {
    const response = await axios.delete(
        `${BASE_URL}/catering/api/admin/delete/${dishId}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: "*/*",
            },
        }
    );

    return response.data;
};

// ======================
// IMPORT EXCEL
// ======================
export const importMenuExcel =
    async (formData, token) => {
        const response = await axios.post(
            `${BASE_URL}/catering/api/admin/import`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "*/*",
                },
            }
        );

        return response.data;
    };


export const getAllMenuItems = async () => {
    const token = localStorage.getItem("authToken");

    const response = await axios.get(
        `${BASE_URL}/food/api/dish/getall`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        }
    );

    return response.data;
};

export const updateDishApproval = async (
    dishId,
    status,
    rejectionReason = ""
) => {

    const token = localStorage.getItem("authToken");

    const response = await axios.put(
        `${BASE_URL}/food/api/dish/approval/${dishId}`,
        {
            status,
            rejectionReason
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        }
    );

    return response.data;
};